import React from 'react'

export type TableHeadProps = {
  children: React.ReactNode
}

export const RdnaTableHead = ({ children }: TableHeadProps) => {
  return <div className="ringdna-table-head">{children}</div>
}
